import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import AutolinkLogo from '../assets/logo.png';
import AutolinkIcon from '../assets/AutolinkIcon.png';

const NAVY = '#071a49';
const GOLD_DEEP = '#9a7410';
const EASE = [0.16, 1, 0.3, 1];

export default function PolicyLayout({ title, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen" style={{ background: '#ffffff' }}>
      {/* top bar */}
      <header
        className="sticky top-0 z-50"
        style={{ background: 'rgba(5,15,51,0.92)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
      >
        <div className="max-w-5xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={AutolinkLogo} alt="AutoLink" className="h-7 w-auto" style={{ filter: 'brightness(0) invert(1)' }} />
          </Link>
          <Link to="/" className="text-sm font-medium text-slate-200 hover:text-white transition-colors">
            ← Back to home
          </Link>
        </div>
      </header>

      {/* brand header */}
      <section className="relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${NAVY} 0%, #3b1b33 100%)` }}>
        <div aria-hidden className="absolute right-0 top-1/2 -translate-y-1/2 pr-2 sm:pr-6 pointer-events-none">
          <img src={AutolinkIcon} alt="" className="w-[260px] sm:w-[340px] max-w-[44vw] select-none" style={{ opacity: 0.1, transform: 'rotate(-12deg)' }} />
        </div>
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 py-16 sm:py-20">
          <motion.h1
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: EASE }}
            className="font-display font-extrabold text-white"
            style={{ fontSize: 'clamp(2rem, 5vw, 3.25rem)', letterSpacing: '-0.03em' }}
          >
            {title}
          </motion.h1>
          {updated && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mt-3 text-slate-300 text-sm"
            >
              Last updated: {updated}
            </motion.p>
          )}
        </div>
      </section>

      {/* body */}
      <main className="flex-1" style={{ background: '#ffffff' }}>
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14 sm:py-16">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="policy-content space-y-8"
          >
            {children}
          </motion.div>
          <div className="mt-12 pt-8 border-t" style={{ borderColor: '#e6eaf2' }}>
            <Link to="/" className="text-sm font-semibold" style={{ color: GOLD_DEEP }}>← Back to home</Link>
          </div>
        </div>
      </main>

      {/* footer */}
      <footer className="py-10 border-t border-white/10" style={{ background: '#03081f' }}>
        <div className="max-w-5xl mx-auto px-5 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <img src={AutolinkLogo} alt="AutoLink" className="h-6 w-auto" style={{ filter: 'brightness(0) invert(1)' }} />
          <div className="flex gap-5 text-sm">
            <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms &amp; Conditions</Link>
            <Link to="/cookies" className="text-slate-400 hover:text-white transition-colors">Cookies</Link>
          </div>
          <div className="text-slate-500 text-sm">© 2026 AutoLink. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}
